import { Box, Card, Skeleton } from "@mui/material";
import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const breakpoints = {
  600: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  900: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  1200: {
    slidesPerView: 4,
    spaceBetween: 10,
  },
  1536: {
    slidesPerView: 5,
    spaceBetween: 10,
  },
};

const MarketWatchTopGainersSkeleton = () => {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={10}
      navigation
      breakpoints={breakpoints}
      modules={[Navigation]}
      className="mySwiper"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <SwiperSlide key={i}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px 12px",
                height: "240px",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", gap: "8px" }}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="text" width={50} />
                </Box>
                <Skeleton variant="text" width={"30%"} />
              </Box>
              <Skeleton variant="rounded" height={"100%"} />
              <Skeleton variant="text" width={"50%"} sx={{ m: "auto" }} />
            </Card>
          </SwiperSlide>
        ))}
      </Box>
    </Swiper>
  );
};

export default MarketWatchTopGainersSkeleton;
